import React from "react";
import { useNavigate } from "react-router-dom";
import BeginnerSidebar from "./BeginnerSidebar";
import "../styles/practice.css";

const BEGINNER_SECTIONS = [
  {
    title: "Practice Set",
    description: "Practise questions and check your answers.",
    icon: "bi-journal-check",
    route: "/beginner/practice",
  },
  {
    title: "Main Exam",
    description: "View your eligibility for the official examination.",
    icon: "bi-file-earmark-text",
    route: "/beginner/main-exam",
  },
];

export default function BeginnerDashboard() {
  const navigate = useNavigate();

  return (
    <div className="oes-page-full practice-page beginner-dashboard">
      <div className="oes-home-shell d-flex flex-row">
        <BeginnerSidebar />

        <main className="flex-grow-1 oes-page container-fluid px-3 px-md-4 py-4">
          <header className="practice-heading">
            <div>
              <span className="practice-eyebrow">
                BEGINNER STUDENT PORTAL
              </span>

              <h1>Welcome to Your Learning Portal</h1>

              <p>
                Practise at your own pace and prepare for your main exam.
              </p>
            </div>
          </header>

          <section className="practice-setup-card">
            <div className="practice-card-heading">
              <div className="practice-icon-tile">
                <i className="bi bi-mortarboard" />
              </div>

              <div>
                <h2>Your Student Portal</h2>
                <p>Choose a section below to continue.</p>
              </div>
            </div>

            <div className="beginner-dashboard-grid">
              {BEGINNER_SECTIONS.map((section) => (
                <button
                  type="button"
                  className="beginner-dashboard-card"
                  key={section.route}
                  onClick={() => navigate(section.route)}
                >
                  <span className="beginner-dashboard-card-icon">
                    <i className={`bi ${section.icon}`} />
                  </span>

                  <span className="beginner-dashboard-card-title">
                    {section.title}
                  </span>

                  <span className="beginner-dashboard-card-description">
                    {section.description}
                  </span>

                  <span className="beginner-dashboard-card-action">
                    Open section
                    <i className="bi bi-arrow-right" />
                  </span>
                </button>
              ))}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

